module.exports = __webpack_public_path__ + "static/media/vector-4966.6c2e9b94.svg";